module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAApklEQVQ4T+3T0QkDIQyA4Zw7dIquUzOjl3SdTtEhLAF7eJpEAgd9aZ580A9/wQ0unu1iD34DEtFDShDxuSpa3pCIbgDwatAdEd8eugSZea+1YkMYEb9r1XXBlsrDyeylm2CXKsn9SLKZ7oEEANl4LzNdBY3U0VbTJ9BJHUE1XQO91BGd0k9gKSWnlASMzCn9AAOpbnoPRlLN9OVPibTL3j8YfbF5/wfK2EEVwFrZZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top.png
// module id = rOIf
// module chunks = 5